export const ARTICLE_LIST_SEND_REQUEST = 'ARTICLE_LIST_SEND_REQUEST';
export const ARTICLE_LIST_RECEIVE_RESPONSE = 'ARTICLE_LIST_RECEIVE_RESPONSE';
